import { Card, Descriptions, Table } from 'antd';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import api from '../utils/api';
import type { Link, AccessLog, PaginatedResponse } from '../types';

export default function LinkDetail() {
  const { id } = useParams<{ id: string }>();
  const [link, setLink] = useState<Link | null>(null);
  const [logs, setLogs] = useState<AccessLog[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) {
      api.get(`links/${id}`).json<{ success: boolean; data: Link }>().then((res) => {
        if (res.success && res.data) setLink(res.data);
      });
      fetchLogs();
    }
  }, [id]);

  const fetchLogs = async (page = 1) => {
    setLoading(true);
    try {
      const res = await api
        .get(`links/${id}/logs?page=${page}&pageSize=10`)
        .json<{ success: boolean; data: PaginatedResponse<AccessLog> }>();
      if (res.success && res.data) {
        setLogs(res.data.items);
      }
    } finally {
      setLoading(false);
    }
  };

  const logColumns = [
    { title: '时间', dataIndex: 'accessed_at', key: 'accessed_at', width: 180 },
    { title: 'IP', dataIndex: 'ip', key: 'ip', width: 140 },
    { title: '国家/城市', key: 'location', render: (_: unknown, r: AccessLog) => `${r.country ?? '-'} / ${r.city ?? '-'}` },
    { title: '设备', dataIndex: 'device_type', key: 'device_type' },
    { title: '浏览器', key: 'browser', render: (_: unknown, r: AccessLog) => `${r.browser ?? '-'} ${r.browser_version ?? ''}` },
    { title: '操作系统', key: 'os', render: (_: unknown, r: AccessLog) => `${r.os ?? '-'} ${r.os_version ?? ''}` },
  ];

  if (!link) return null;

  return (
    <div>
      <h2 style={{ marginBottom: 24 }}>短链详情</h2>
      <Card title="基本信息" style={{ marginBottom: 24 }}>
        <Descriptions>
          <Descriptions.Item label="短链代码">{link.short_code}</Descriptions.Item>
          <Descriptions.Item label="目标 URL">{link.target_url}</Descriptions.Item>
          <Descriptions.Item label="访问次数">{link.visit_count}</Descriptions.Item>
          <Descriptions.Item label="状态">{link.is_active ? '活跃' : '停用'}</Descriptions.Item>
          <Descriptions.Item label="创建时间">{link.created_at}</Descriptions.Item>
          <Descriptions.Item label="过期时间">{link.expires_at ?? '永不过期'}</Descriptions.Item>
        </Descriptions>
      </Card>

      <Card title="访问日志" style={{ marginBottom: 24 }}>
        <Table
          columns={logColumns}
          dataSource={logs}
          rowKey="id"
          loading={loading}
          pagination={{ pageSize: 10 }}
        />
      </Card>
    </div>
  );
}
